import { _t } from "core/language";
import React, { memo, useEffect, useState } from "react";

import ThemeCard from "./ThemeCard";
import { TypeSuggestion } from "../type";
import { useSuggestionByType } from "../hooks";
import SectionSkeleton from "./SectionSkeleton";
import MainNodata from "./NodataComponent";
import FoodImage1 from "../assets/images/FoodSuggest-1.jpg";
import FoodImage2 from "../assets/images/FoodSuggest-2.jpg";
import FoodImage3 from "../assets/images/FoodSuggest-3.jpg";
import FoodImage4 from "../assets/images/FoodSuggest-4.jpg";
import FoodImage5 from "../assets/images/FoodSuggest-5.jpg";
import IconSectionSuggestion from "./icon/IconSectionSuggestion";
const FoodImage = [FoodImage1, FoodImage2, FoodImage3, FoodImage4, FoodImage5];
// import IconTitle from "../assets/images/icon_section_suggestion.svg";

const FoodSuggestions = ({refresh}:any) => {
  const [paramsSituation, setParamsSituation] = useState({
    type: TypeSuggestion.SITUATION,
    refresh: refresh
  });

  useEffect(() => {
    setParamsSituation({
        type: TypeSuggestion.SITUATION,
        refresh: refresh,
      })
  }, [refresh]);

  const mapTextItemSuggest = (item: any, index:number) => {
    const result = item;
    result[0].title = _t(`main.suggest_item_title${index+1}`);
    result[0].description = _t(`main.suggest_item_description${index+1}`);
    return result;
  }

  const [situations, loading] = useSuggestionByType(paramsSituation);
  const hasData = situations?.items?.length > 0;
  return (
    <section className="mt-2 py-[20px] bg-white  ">
      <div className="pl-4">
        <h2 className="z-10 text-[#777777] text-[12px] font-medium">
          {/* {situations.title} */}
          {_t("main.suggest_section_title")}
        </h2>
        <h1 className="text-[16px] font-bold text-[#111111] flex items-center">
          <div className="mr-1">
            <IconSectionSuggestion />
          </div>
          {/* {situations.description} */}
          {_t("main.suggest_section_description")}
        </h1>
      </div>
      <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
        <div className="flex flex-row mt-3.5 px-4">
          {(loading && !hasData) && <SectionSkeleton />}
          {(situations?.items || []).map((situation: any, index: number) => {
            situation.translates = mapTextItemSuggest(situation.translates, index);
            return <ThemeCard
            key={index}
            {...situation}
            thumbnail={FoodImage[index] || situation.thumbnail}
          />
          })}
        </div>
        <MainNodata
          loading={loading}
          data={situations}
          text={_t("main.no_data")}
        />
      </div>
    </section>
  );
};

export default memo(FoodSuggestions);
